import { render, staticRenderFns } from "./DueInvoicesTest.vue?vue&type=template&id=86858bce"
import script from "./DueInvoicesTest.vue?vue&type=script&lang=js"
export * from "./DueInvoicesTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports